
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Loader";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Loader__root","statusIndicator":"wds_1_76_1_Loader__statusIndicator","arcsContainer":"wds_1_76_1_Loader__arcsContainer","darkArc":"wds_1_76_1_Loader__darkArc","lightArc":"wds_1_76_1_Loader__lightArc","text":"wds_1_76_1_Loader__text"};
export var keyframes = {"rotation":"wds_1_76_1_Loader__rotation","staggered-rotation":"wds_1_76_1_Loader__staggered-rotation"}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




